import { i18n } from "@/main.js";
export const getDuration = (stamp, tem) => {
  const hour = Math.floor(stamp / (1000 * 60 * 60));
  let ms = stamp - hour * 1000 * 60 * 60;
  const min = Math.floor(ms / (1000 * 60));
  ms = ms - min * 1000 * 60;
  const sec = Math.floor(ms / 1000);
  return tem
    .replace("hh", hour > 0 ? hour : "0" + hour)
    .replace("mm", min > 9 ? min : "0" + min)
    .replace("ss", sec > 9 ? sec : "0" + sec);
};

export const getMonth = (date, tem) => {
  const year = date.getFullYear();
  const mon = date.getMonth() + 1;
  return tem.replace("yy", year).replace("mm", mon > 9 ? mon : "0" + mon);
};

export const getDate = (timeStamp, tem) => {
  const date = new Date(timeStamp * 1000);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  month = month > 9 ? month : "0" + month;
  let day = date.getDate();
  day = day > 9 ? day : "0" + day;
  let hour = date.getHours();
  hour = hour > 9 ? hour : "0" + hour;
  let min = date.getMinutes();
  min = min > 9 ? min : "0" + 9;
  let sec = date.getSeconds();
  sec = sec > 9 ? sec : "0" + sec;
  return tem
    .replace("yy", year.toString())
    .replace("mm", month.toString())
    .replace("dd", day.toString())
    .replace("hh", hour.toString())
    .replace("mt", min.toString())
    .replace("ss", sec.toString());
};

export const getWeek = () => {
  const tempDate = new Date();
  const days = tempDate.getDay();
  return days;
};

// 格式化日期
function formatDate(date) {
  date = new Date(date);
  let myyear = date.getFullYear();
  let mymonth = date.getMonth() + 1;
  let myweekday = date.getDate();
  mymonth < 10 ? (mymonth = "0" + mymonth) : mymonth;
  myweekday < 10 ? (myweekday = "0" + myweekday) : myweekday;
  return `${myyear}.${mymonth}.${myweekday}`;
}
// 格式化日期
export function formatTime(date) {
  var date = new Date(date);
  // let Y = date.getFullYear() + '-';
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  let D = date.getDate() + " ";
  let h = date.getHours() + ":";
  let m = date.getMinutes() + ":";
  let s = date.getSeconds();
  return M + D + h + m + s;
}
//获取本周所有日期 周一 至 周日
export const getWeekDay = () => {
  let dateString = formatDate(new Date()); //当天的日期，例如2020-2-28
  let presentDate = new Date(dateString);
  let today = presentDate.getDay() !== 0 ? presentDate.getDay() : 7;

  return Array.from(new Array(7), function (val, index) {
    return formatDate(
      new Date(
        presentDate.getTime() - (today - index - 1) * 24 * 60 * 60 * 1000
      )
    );
  });
};

function getZ(num) {
  switch (num) {
    case 1:
      return i18n.t("common.Monday");
    case 2:
      return i18n.t("common.Tuesday");
    case 3:
      return i18n.t("common.Wednesday");
    case 4:
      return i18n.t("common.Thursday");
    case 5:
      return i18n.t("common.Friday");
    case 6:
      return i18n.t("common.Saturday");
    case 0:
      return i18n.t("common.Sunday");
  }
}
function getX(num) {
  switch (num) {
    case 1:
      return i18n.t("common.Monday");
    case 2:
      return i18n.t("common.Tuesday");
    case 3:
      return i18n.t("common.Wednesday");
    case 4:
      return i18n.t("common.Thursday");
    case 5:
      return i18n.t("common.Friday");
    case 6:
      return i18n.t("common.Saturday");
    case 0:
      return i18n.t("common.Sunday");
  }
}
export const dayCount = (AddDayCount, dd = new Date()) => {
  if (typeof dd == "string") {
    dd = new Date(dd);
  }
  dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1; //获取当前月份的日期
  if (m > 0 && m < 10) {
    m = "0" + m;
  }
  var d = dd.getDate();
  if (d > 0 && d < 10) {
    d = "0" + d;
  }
  var h = dd.getHours();
  if (h > 0 && h < 10) {
    h = "0" + h;
  }
  var i = dd.getMinutes();
  if (i > 0 && i < 10) {
    i = "0" + i;
  }
  var s = dd.getSeconds();
  if (s > 0 && s < 10) {
    s = "0" + s;
  }
  var num = dd.getDay();
  var time = dd.setHours(0, 0, 0, 0); //当天零点时间戳
  let val = {
    year: y,
    month: m,
    day: d,
    hour: h,
    minute: i,
    second: s,
    week: getZ(num),
    week2: getX(num),
    ymd: y + "-" + m + "-" + d,
    md: m + "-" + d,
    hi: h + ":" + i,
    ymdhis: y + "-" + m + "-" + d + " " + h + ":" + i + ":" + s,
    timeStamp: time,
    addDayCount: AddDayCount,
  };
  return val;
};

export function s_to_hs(s) {
  //计算分钟
  //算法：将秒数除以60，然后下舍入，既得到分钟数
  var h;
  h = Math.floor(s / 60);
  //计算秒
  //算法：取得秒%60的余数，既得到秒数
  s = s % 60;
  //将变量转换为字符串
  h += "";
  s += "";
  //如果只有一位数，前面增加一个0
  h = h.length == 1 ? "0" + h : h;
  s = s.length == 1 ? "0" + s : s;
  return h + ":" + s;
}

/**
 * 日期格式化
 * date--> 可以是 时间戳 和 标准的日期格式
 * fmt 年月日时分秒 --> 'yyyy-MM-dd hh:mm:ss'
 * ex --> format(new Date(), 'yyyy-MM-dd hh:mm:ss')
 * -----> 2022-03-04 17:21:02
 */
export function format(date, fmt = "yyyy-MM-dd hh:mm:ss") {
  date = new Date(date);
  const o = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (const k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
}

//时间戳转天数 剩余天数
export function stampToDay(time) {
  let rangeDateNum = (time * 1000 - new Date().valueOf()) / (1000 * 3600 * 24);
  if (rangeDateNum < 0) {
    return (rangeDateNum = 0);
  }
  rangeDateNum = Math.ceil(rangeDateNum);
  return rangeDateNum;
}
